import React from 'react';
import { SOCIAL_LOGO_AND_LINKS } from '../../constants';
import { Wrapper, SocialLogoWrapper, SocialLogo } from './index.style';
import Logo from '@lendi-ui/logo';
import { FooterAnalyticsContext } from '../utils/analytics';

export const Social: React.FC = () => {
  const { analyticsForFooter } = React.useContext(FooterAnalyticsContext);

  return (
    <Wrapper>
      <Logo variant="light" />
      <SocialLogoWrapper>
        {SOCIAL_LOGO_AND_LINKS.map((social) => {
          const LogoIcon = social.logo;
          return (
            <SocialLogo
              key={social.url}
              href={social.url}
              onClick={() => {
                analyticsForFooter('logo', 'Logo');
              }}
            >
              <LogoIcon color="shade.0" />
            </SocialLogo>
          );
        })}
      </SocialLogoWrapper>
    </Wrapper>
  );
};
